export const links = {
  cashOnDelivery: 'https://www.99minutos.com/cash99/',
  insurance: '',
  tailor99: 'https://www.99minutos.com/tailor99/',
  sameDay: 'https://www.99minutos.com/envios99/',
  sprint: 'https://www.99minutos.com/envios99/',
  express: 'https://www.99minutos.com/envios99/',
  co2Free: 'https://www.99minutos.com/envios99/',
  return: 'https://www.99minutos.com/envios99/',
  p2p: '',
  fulfill99: 'https://www.99minutos.com/fulfill99/',

  point99: 'https://www.99minutos.com/punto99/',
  route99: '',
  national: '',
  parcel: '',
};

export const traslateLabels = {
  cashOnDelivery: 'COD',
  insurance: 'Seguro',
  fulfill99: 'fulfill99',
  express: '99minutos',
  point99: 'punto99',
  route99: 'ruta99',
  co2Free: 'CO2 Free',
  sprint: 'Sprint',
  return: 'Retorno',
  national: 'Nacional',
  p2p: 'P2P',
  sameDay: 'Same Day',
  parcel: 'Parcel',
  tailor99: 'tailor99',
};

export const servicesByCountry = {
  MEX: [
    'cashOnDelivery',
    'insurance',
    'tailor99',
    'sameDay',
    'sprint',
    'express',
    'co2Free',
    'return',
    'p2p',
    'fulfill99',
    'point99',
    'national',
    'route99',
    'parcel',
  ],
  COL: [
    'cashOnDelivery',
    'insurance',
    'tailor99',
    'sameDay',
    'sprint',
    'return',
    'fulfill99',
    'route99',
    'parcel',
  ],
  PER: ['tailor99', 'sameDay', 'sprint', 'return', 'route99', 'parcel'],
  CHL: ['tailor99', 'sameDay', 'sprint', 'return', 'route99', 'parcel'],
};

export const creditServicesbyCountry = {
  CHL: ['tailor99', 'sameDay', 'return', 'sprint'],
  COL: ['sameDay'],
};
